import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-510bff08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password" }
const _hoisted_2 = { class: "code" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "downtxt"
}
const _hoisted_5 = { class: "displayflex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mobile_outlined = _resolveComponent("mobile-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_unlock_outlined = _resolveComponent("unlock-outlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_file_image_outlined = _resolveComponent("file-image-outlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_field_number_outlined = _resolveComponent("field-number-outlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_check_circle_outlined = _resolveComponent("check-circle-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showflag)
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 0,
          class: "item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: "",
                      style: {"width":"100%"}
                    }, _ctx.validateInfos.phone), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.modelRef.phone,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.phone) = $event)),
                          placeholder: _ctx.t('page.personal.center.compontent.bindphone.tips')
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_component_mobile_outlined)
                          ]),
                          _: 1
                        }, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 16),
                    (_ctx.typeStr=='phone')
                      ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                          key: 0,
                          label: "",
                          style: {"width":"100%"}
                        }, _ctx.validateInfos.password), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_password, {
                              value: _ctx.modelRef.password,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.password) = $event)),
                              placeholder: _ctx.t('page.personal.center.compontent.password.tips')
                            }, {
                              prefix: _withCtx(() => [
                                _createVNode(_component_unlock_outlined)
                              ]),
                              _: 1
                            }, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 16))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_row, { gutter: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, _mergeProps({
                              label: "",
                              style: {"width":"100%"}
                            }, _ctx.validateInfos.code), {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: _ctx.modelRef.code,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.code) = $event)),
                                  placeholder: _ctx.t('page.personal.center.compontent.codenumber.tips')
                                }, {
                                  prefix: _withCtx(() => [
                                    _createVNode(_component_file_image_outlined)
                                  ]),
                                  _: 1
                                }, 8, ["value", "placeholder"])
                              ]),
                              _: 1
                            }, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_2, [
                              _createElementVNode("img", {
                                src: _ctx.imgUrl,
                                alt: ""
                              }, null, 8, _hoisted_3)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 4 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "link",
                              onClick: _ctx.handleChangeIt
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.btnchangetxt')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 15 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, _mergeProps({
                              label: "",
                              style: {"width":"100%"}
                            }, _ctx.validateInfos.phoneCode), {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: _ctx.modelRef.phoneCode,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.phoneCode) = $event)),
                                  placeholder: _ctx.t('page.personal.center.compontent.msgnumber.tips')
                                }, {
                                  prefix: _withCtx(() => [
                                    _createVNode(_component_field_number_outlined)
                                  ]),
                                  _: 1
                                }, 8, ["value", "placeholder"])
                              ]),
                              _: 1
                            }, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 9 }, {
                          default: _withCtx(() => [
                            (_ctx.downflag)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "link",
                                  onClick: _ctx.handleSendMsg
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.txtflag?
                                    _ctx.t('page.personal.center.compontent.verificationtxt'):
                                    _ctx.t('page.personal.center.compontent.verificationtxtrepeat')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.count) + _toDisplayString(_ctx.t('page.personal.center.compontent.countdown.tips')), 1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, { class: "displayflex" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            (_ctx.typeStr!=='phone')
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: _ctx.handleSubmit
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.phone.btnconfirm')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_a_button, {
                                  key: 1,
                                  type: "primary",
                                  onClick: _ctx.handleSubmit
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.phone.btnconfirm.change')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])),
                            _createVNode(_component_a_button, { onClick: _ctx.handleCtrl }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.btnctrl')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_a_row, {
          key: 1,
          class: "item-t"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_check_circle_outlined, { class: "icon-b" }),
              _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.bindsuccess')), 1)
            ]),
            _createVNode(_component_a_button, {
              type: "primary",
              style: {"margin-top":"20px","width":"40%"},
              onClick: _ctx.handleCtrl
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.close')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
  ]))
}